module.exports = {"title":"Download your tickets","content":"Click on the button to download your tickets.","download":"Download","msg":{"yay":"Yay!","oops":"Oops!","error":"Your token is invalid."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountBalance/locales/fr.json
// module id = 1972
// module chunks = 0